import { RRuleTemporal } from "rrule-temporal";
import { Temporal } from "temporal-polyfill";
//#region src/components/RRule/utils/rrule-codec.ts
function regionNow(timeZone, now) {
	return Temporal.Instant.from(now.toISOString()).toZonedDateTimeISO(timeZone);
}
function asFreq(freq) {
	if (freq === "WEEKLY" || freq === "MONTHLY") return freq;
	return "DAILY";
}
function first(values, fallback) {
	return typeof values?.[0] === "number" ? values[0] : fallback;
}
function dtstartClock(dtstart) {
	return {
		hour: typeof dtstart.hour === "number" ? dtstart.hour : 0,
		minute: typeof dtstart.minute === "number" ? dtstart.minute : 0,
		second: typeof dtstart.second === "number" ? dtstart.second : 0
	};
}
function serializeRRule(parts, timeZone, now = /* @__PURE__ */ new Date()) {
	const dtstart = regionNow(timeZone, now).with({
		hour: parts.byHour,
		microsecond: 0,
		millisecond: 0,
		minute: parts.byMinute,
		nanosecond: 0,
		second: parts.bySecond
	});
	return new RRuleTemporal({
		byDay: parts.freq === "WEEKLY" ? parts.byDay : void 0,
		byHour: [parts.byHour],
		byMinute: [parts.byMinute],
		byMonthDay: parts.freq === "MONTHLY" ? parts.byMonthDay : void 0,
		bySecond: [parts.bySecond],
		dtstart,
		freq: parts.freq,
		temporal: Temporal,
		tzid: timeZone
	}).toString();
}
/** Wall-clock RRULE with no DTSTART; evals can read BYHOUR before TZ hydrates. */
function serializeUnanchoredRRule(parts) {
	const rule = [`FREQ=${parts.freq}`];
	if (parts.freq === "WEEKLY" && parts.byDay.length > 0) rule.push(`BYDAY=${parts.byDay.join(",")}`);
	if (parts.freq === "MONTHLY" && parts.byMonthDay.length > 0) rule.push(`BYMONTHDAY=${parts.byMonthDay.join(",")}`);
	rule.push(`BYHOUR=${parts.byHour}`, `BYMINUTE=${parts.byMinute}`, `BYSECOND=${parts.bySecond}`);
	return `RRULE:${rule.join(";")}`;
}
var DTSTART_LINE = /(?:^|\r?\n)DTSTART/i;
function rruleHasDtstart(rruleString) {
	return DTSTART_LINE.test(rruleString);
}
function parseRRule(rruleString) {
	if (!rruleString.trim()) return null;
	const hasDtstart = DTSTART_LINE.test(rruleString);
	try {
		const opts = new RRuleTemporal({ rruleString: hasDtstart ? rruleString : `DTSTART;TZID=UTC:19700101T000000\n${rruleString}` }).options();
		const clock = dtstartClock(opts.dtstart);
		return {
			byDay: opts.byDay ?? [],
			byHour: first(opts.byHour, clock.hour),
			byMinute: first(opts.byMinute, clock.minute),
			byMonthDay: opts.byMonthDay ?? [],
			bySecond: first(opts.bySecond, clock.second),
			freq: asFreq(opts.freq),
			tzid: hasDtstart ? opts.tzid : void 0
		};
	} catch {
		return null;
	}
}
//#endregion
export { parseRRule, rruleHasDtstart, serializeRRule, serializeUnanchoredRRule };

//# sourceMappingURL=rrule-codec.js.map